import { render, staticRenderFns } from "./VimeoPlayer.vue?vue&type=template&id=c3fa173e"
import script from "./VimeoPlayer.vue?vue&type=script&lang=js"
export * from "./VimeoPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports